import React from 'react';
const faqs = [{
  question: '¿Es todo legal?',
  answer: 'Sí, 100%. Todo está dentro del marco regulatorio argentino vigente. Nada ilegal, nada turbio — solo información que ya existe y que tenés derecho a usar.'
}, {
  question: '¿Funciona para EDESUR, EDENOR y distribuidoras del interior?',
  answer: 'Sí. Funciona para cualquier distribuidora de Argentina. La guía incluye ejemplos de las principales zonas del país: CABA, GBA, Córdoba, Rosario, Mendoza, Tucumán y más.'
}, {
  question: '¿Necesito conocimientos técnicos o de electricidad?',
  answer: 'Para nada. Si podés leer una factura, podés aplicar esto. Está escrito en argentino, sin tecnicismos, con pasos claros.'
}, {
  question: '¿Cuándo recibo la guía?',
  answer: 'Inmediatamente después del pago. Te llega el link de descarga directo a tu email en menos de 2 minutos. Sin esperas.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tenés 15 días de garantía total. Si no estás conforme por cualquier motivo, te devolvemos el dinero completo. Sin preguntas, sin formularios.'
}, {
  question: '¿Es un PDF? ¿Cómo lo abro?',
  answer: 'Sí, es un PDF descargable. Lo abrís en cualquier celular, tablet o computadora. No necesitás instalar nada especial.'
}];
export function FAQSection() {
  return <section style={{
    background: '#0d1420',
    padding: '80px 16px'
  }} data-id="element-88">
      <div style={{
      maxWidth: '680px',
      margin: '0 auto'
    }} data-id="element-89">
        <h2 style={{
        color: 'white',
        fontSize: 'clamp(24px, 4vw, 36px)',
        fontWeight: 900,
        textTransform: 'uppercase',
        textAlign: 'center',
        margin: '0 0 48px',
        fontFamily: 'inherit',
        letterSpacing: '-0.02em'
      }} data-id="element-90">
          Preguntas frecuentes
        </h2>

        {faqs.map((faq, index) => <details key={index} style={{
        borderBottom: '1px solid #1e293b',
        marginBottom: 0
      }} data-id="element-91">
            <summary style={{
          padding: '20px 0',
          color: 'white',
          fontWeight: 600,
          fontSize: '17px',
          cursor: 'pointer',
          listStyle: 'none',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontFamily: 'inherit'
        }} data-id="element-92">
              {faq.question}
              <span style={{
            color: '#3b82f6',
            fontSize: '22px',
            fontWeight: 300
          }} data-id="element-93">
                +
              </span>
            </summary>
            <p style={{
          color: '#94a3b8',
          fontSize: '16px',
          lineHeight: 1.7,
          padding: '0 0 20px',
          margin: 0
        }} data-id="element-94">
              {faq.answer}
            </p>
          </details>)}
      </div>
    </section>;
}